export const isRequired = (value) => value != null && String(value).trim().length > 0;

export const isValidEmail = (value) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());

export const isValidPhone = (value) =>
  /^[+]?[\d\s-]{7,15}$/.test(String(value).trim());

export function validateEnquiryForm(values) {
  const errors = {};
  if (!isRequired(values.fullName)) errors.fullName = "Please enter your full name.";
  if (!isRequired(values.phone)) errors.phone = "Please enter a phone number.";
  else if (!isValidPhone(values.phone)) errors.phone = "Enter a valid phone number.";
  if (!isRequired(values.email)) errors.email = "Please enter your email address.";
  else if (!isValidEmail(values.email)) errors.email = "Enter a valid email address.";
  if (!isRequired(values.goal)) errors.goal = "Please select a fitness goal.";
  if (!isRequired(values.program)) errors.program = "Please select a preferred program.";
  if (!values.consent) errors.consent = "Please accept the consent checkbox to continue.";
  return errors;
}

export function calculateBMI(heightCm, weightKg) {
  const h = parseFloat(heightCm);
  const w = parseFloat(weightKg);
  if (!h || !w || h <= 0 || w <= 0) return null;
  const meters = h / 100;
  const bmi = w / (meters * meters);
  return Math.round(bmi * 10) / 10;
}

export function bmiCategory(bmi) {
  if (bmi == null) return null;
  if (bmi < 18.5) return { label: "Underweight", tone: "info" };
  if (bmi < 25) return { label: "Healthy Range", tone: "good" };
  if (bmi < 30) return { label: "Overweight", tone: "warn" };
  return { label: "Obese", tone: "alert" };
}
